import React, { useCallback, useEffect, useState } from 'react';

const concatAudio = async (ctx, ids, gap = 0) => {
  const notFoundBuf = (await fetch('/cough.mp3')).arrayBuffer()
  const arrayBufs = (await Promise.allSettled(
    Object.values(ids).filter(x => x).map(async (id) => {
      const src = `/audio/${id}.mp3`
      const res = await fetch(src)
      if (res.status === 200) {
        return res.arrayBuffer()
      }

      return notFoundBuf
    })
  )).map(({ value }) => value).filter(x => x)

  const buffers = (await Promise.all(arrayBufs.map(b => ctx.decodeAudioData(b))))
  const maxNumberOfChannels = Math.max(...buffers.map((buffer) => buffer.numberOfChannels));

  const totalLength = buffers.map((buffer) => buffer.length).reduce((a, b) => a + b, 0)
  const output = ctx.createBuffer(
    maxNumberOfChannels,
    totalLength,
    buffers[0].sampleRate
  )

  // TODO: add paddings for pauses
  let offset = 0;
  buffers.forEach((buffer) => {
    for (let channelNumber = 0; channelNumber < buffer.numberOfChannels; channelNumber++) {
      output.getChannelData(channelNumber)
        .set(
          buffer.getChannelData(channelNumber)
            .slice(gap, buffer.length - gap * buffer.sampleRate), 
          offset
        );
    }

    offset += buffer.length;
  });


  return output
}

const audioContext = new AudioContext()

function TextPlayer ({ text, words, active, paused, gap, onEnded, ...additionalProps }) {
  const [ids, setIds] = useState([])
  const [tokens, setTokens] = useState([])
  const [audioSource, setAudioSource] = useState([])

  useEffect(() => {
    if (active && ids && ids.length > 0) {
      concatAudio(audioContext, ids, gap).then(async out => {
        const newAudioSource = audioContext.createBufferSource();
        newAudioSource.buffer = out
        newAudioSource.connect(audioContext.destination);

        try {
          if (audioSource) {
            audioSource.onended = null
            audioSource.stop()
          }
        } catch (err) {}

        setAudioSource(newAudioSource)
      })
    }
  }, [ids, gap, active])

  useEffect(() => {
    if (audioSource && active && !paused) {
      try {
        audioSource.onended = null
        audioSource.stop()
      } catch (err) {}

      audioSource.start()
      audioSource.onended = () => onEnded()
    }

    if (audioSource && (!active || (active && paused))) {
      try {
        audioSource.onended = null
        audioSource.stop()
      } catch (err) {}

      if (!active) {
        setAudioSource(null)
      }
    }
  }, [active, paused, audioSource])

  useEffect(() => {
    if (!words.length || !text) return

    const tokensLocal = text.split(' ')
    const idsLocal = new Array(tokensLocal.length).fill(null)
    const pausesLocal = new Array(tokensLocal.length).fill(null)

    tokensLocal.forEach((word, i) => {
      if (/^[^a-zA-Z]+$/.test(word) || /[?.;—]/.test(word)) {
        pausesLocal[i] = 300
      } else if (word.endsWith(',')) {
        pausesLocal[i] = 100
      }

      const normalized = word
        .toLowerCase()
        .replace(',', '')
        .replace('.', '')
        .replace('?', '')
        .replace(';', '')
        .replace('**', '')
        .replace('—', '')
        .replace(/^“/, '')
        .replace(/”$/, '')

      const wordIndex = words.indexOf(normalized)
      if (wordIndex !== -1) {
        idsLocal[i] = wordIndex
      }
    })

    setTokens(tokensLocal)
    setIds(idsLocal)

  }, [words, text])

  return <div {...additionalProps} className={active ? 'active' : ''}>
    {tokens && tokens.length > 0 && tokens.map((token, i) => 
      <span>{token}{' '}</span>)}
  </div>
}

export default TextPlayer
